import { render, staticRenderFns } from "./find-someone-cheating-online-for-free.vue?vue&type=template&id=45f3ad4c"
import script from "./find-someone-cheating-online-for-free.vue?vue&type=script&lang=js"
export * from "./find-someone-cheating-online-for-free.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/app/components/Navigation.vue').default,FooterMain: require('/app/components/FooterMain.vue').default})
